<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="(date | titlecase) + (local ? ' | ' + local : '')"
  (click)="onClickWidget()"
>

  <app-widget-principal-data
    label="%"
    progressColor="#F64E60"
    [isDataGrid]="true"
    [data]="widgetData.porcentaje | number: '1.0-0'"
    [progress]="widgetData.porcentaje / 100"
    [showData]="loadedData || isStoreView"
  >

    <div extra-data class="extra-data-wrapper">

      <div class="extra-data">
        {{ widgetData.importe | currency: 'EUR': 'symbol': '1.0-0': 'es' }}
      </div>

      <div
        class="percentage"
        [ngClass]="{'danger': widgetData.last_porcentaje <= widgetData.porcentaje}"
      >
        <yu-icon
          [name]="widgetData.last_porcentaje <= widgetData.porcentaje ? 'arrow-circle-up' : 'arrow-circle-down'"
        ></yu-icon>

        {{ widgetData.diferencia_porcentaje | number: '1.0-0' }} %
      </div>

    </div>

  </app-widget-principal-data>

</app-widget-home-core>
